import React, { Fragment, useMemo, useState } from 'react';
import { withRouter } from 'react-router';
import { Modal, ModalBody, ModalHeader, NavItem, NavLink } from 'reactstrap';
import loadable from '@loadable/component';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';

const CreateReadingView = loadable(() => {
  return import('./../../' + window.config.consul.CLIENT + '/views/CreateReading/CreateReadingView').catch(
    () => import('./../../views/Missing'),
  );
});

const jwt = require('jsonwebtoken');

function QuickCreateReadingModal() {
  const [showQuickCreateReadingModal, setShowQuickCreateReadingModal] = useState(false);

  // Build a dedicated Apollo client for the modal to ensure context is available inside portals
  const apolloClient = useMemo(() => {
    const graphUrlBase = (window.config && window.config.consul && window.config.consul.GRAPHQL_URL) || '';

    const httpLink = createHttpLink({
      uri: `${graphUrlBase}/graphql`,
    });

    const authLink = setContext((_, { headers }) => {
      const token = sessionStorage.mstoken ? sessionStorage.mstoken : localStorage.token;
      return {
        headers: {
          ...headers,
          authorization: token ? `Bearer ${token}` : null,
          msToken: sessionStorage.mstoken,
        },
      };
    });

    const errorLink = onError(() => {
      // intentionally minimal; app-level error UI exists
    });

    return new ApolloClient({
      link: authLink.concat(errorLink).concat(httpLink),
      cache: new InMemoryCache({ addTypename: false }),
      shouldBatch: true,
      defaultOptions: {
        watchQuery: { fetchPolicy: 'cache-and-network', errorPolicy: 'ignore' },
      },
    });
  }, []);

  const toggleModal = () => setShowQuickCreateReadingModal((prev) => !prev);

  const token = sessionStorage.mstoken ? sessionStorage.mstoken : localStorage.token;
  const decodedToken = jwt.decode(token);
  const organization =
    decodedToken && decodedToken.organizations && decodedToken.organizations.length === 1
      ? decodedToken.organizations[0]
      : null;

  return (
    <Fragment>
      <NavItem>
        <NavLink
          className='quick-link'
          href='#'
          onClick={(e) => {
            e.preventDefault();
            setShowQuickCreateReadingModal(true);
          }}
        >
          <i className='icon ion-plus-round'></i>&nbsp;&nbsp;{'Submit Reading'}
        </NavLink>
      </NavItem>

      <Modal
        isOpen={showQuickCreateReadingModal}
        toggle={toggleModal}
        size={'lg'}
        style={{ width: '90%' }}
        className='quick-create-reading-modal'
      >
        <ModalHeader toggle={toggleModal}>Create Reading</ModalHeader>
        <ModalBody style={{ paddingBottom: '50px' }}>
          <ApolloProvider client={apolloClient}>
            {!!showQuickCreateReadingModal && organization && <CreateReadingView predefinedCustomer={organization} />}
            {!!showQuickCreateReadingModal && !organization && <CreateReadingView />}
          </ApolloProvider>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default withRouter(QuickCreateReadingModal);
